<template>
  <div class="route-search">
    <TitleFrame
      text="観光"
      :dense="true"
      @click-close="onClickCloseSelectSpot"
      :showReturn="openSelectSpotModal"
    >
      <template slot="contents">
        <div class="tab">
          <div
            class="tab-item"
            :class="{ current: tabs.dropspot === 0 }"
            @click="onClickTab(0)"
          >
            経路検索
          </div>
          <div
            class="tab-item"
            :class="{ current: tabs.dropspot === 1 }"
            @click="onClickTab(1)"
          >
            スポット検索
          </div>
        </div>
        <RouteSearchInputs
          @click-search="onClickSearch"
          v-if="tabs.dropspot === 0"
        />
        <RouteSearchSpot
          v-if="tabs.dropspot === 1"
          :list="aroundAreaData"
          :openSelectSpotDialog="openSelectSpotModal"
          @click-search="onClickSearch"
          @click-close-select-spot="onClickCloseSelectSpot"
          @click-open-select-spot="onClickOpenSelectSpot"
        />
        <div class="map-area" :class="{ tab1: tabs.dropspot === 1 }">
          <GoogleMapOnlyCurrent
            v-if="currentLat && currentLng"
            :current="current"
          />
        </div>
        <Caution />
      </template>
    </TitleFrame>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import TitleFrame from "@/components/Templates/TitleFrame";
import RouteSearchInputs from "@/components/Organisms/RouteSearchInputs";
import RouteSearchSpot from "@/components/Organisms/RouteSearchSpot";
import Caution from "@/components/RouteSearch/Caution";
import GoogleMapOnlyCurrent from "@/components/Organisms/GoogleMapOnlyCurrent";
import Firebase from "./../../firebase";
import axios from "axios";

export default {
  name: "route-search",
  components: {
    TitleFrame,
    RouteSearchInputs,
    RouteSearchSpot,
    GoogleMapOnlyCurrent,
    Caution,
  },
  props: {
    current: { type: String, default: false, required: true },
  },
  computed: {
    ...mapState([
      "currentLat",
      "currentLng",
      "DepLatLng",
      "DesLatLng",
      "tabs",
      "search",
      "currentPageName",
    ]),
    currentDepLatLng() {
      if (this.current === "RouteSearch") {
        return this.DepLatLng.dropspot;
      } else if (this.current === "MyPage") {
        return this.DepLatLng.mypage;
      } else if (this.current === "JyutaiSearch") {
        return this.DepLatLng.jyutai;
      }
    },
    currentDesLatLng() {
      if (this.current === "RouteSearch") {
        return this.DesLatLng.dropspot;
      } else if (this.current === "MyPage") {
        return this.DesLatLng.mypage;
      } else if (this.current === "JyutaiSearch") {
        return this.DesLatLng.jyutai;
      }
    },
    currentSearch() {
      if (this.current === "RouteSearch") {
        return this.search.dropspot;
      } else if (this.current === "JyutaiSearch") {
        return this.search.jyutai;
      }
    },
    currentSearchDep() {
      if (this.currentSearch.departure === "現在地") {
        return this.currentDepLatLng;
      }
      return this.currentSearch.departure;
    },
    currentSearchDes() {
      if (this.currentSearch.destination === "現在地") {
        return this.currentDesLatLng;
      }
      return this.currentSearch.destination;
    },
  },
  methods: {
    ...mapMutations([
      "setSearch",
      "loadingStartMini",
      "loadingEndMini",
      "setSelectedTab",
      "setSearchState",
      "setDepLatLng",
      "setDesLatLng",
    ]),
    onClickTab(payload) {
      this.setSelectedTab(payload);
    },
    async onClickSearch(e) {
      this.loadingStartMini();
      this.setSearch(e);
      await this.getGeo(e.departure, true);
      await this.getGeo(e.destination, false);
      await this.searchRoute();
      this.loadingEndMini();
      this.setSearchState("select");
    },
    async getGeo(text, dep) {
      const re = new RegExp("^[0-9]{1,3}.[0-9]*.* [0-9]{1,3}.[0-9]*");
      if (re.test(text)) {
        const coord = new RegExp("([0-9]{1,3}.[0-9]*)", "g");
        let parsedString = text.match(coord);
        let latlng = new window.google.maps.LatLng(
          parsedString[0],
          parsedString[1],
        );
        if (dep) {
          this.setDepLatLng(latlng);
        } else {
          this.setDesLatLng(latlng);
        }
        return;
      }
      if (text === "現在地") {
        let latlng = new window.google.maps.LatLng(
          this.currentLat,
          this.currentLng,
        );
        if (dep) {
          this.setDepLatLng(latlng);
        } else {
          this.setDesLatLng(latlng);
        }
        return;
      }
      const setDepLatLng = this.setDepLatLng;
      const setDesLatLng = this.setDesLatLng;
      const geocoder = new window.google.maps.Geocoder();
      const loadingEndMini = this.loadingEndMini;
      await geocoder.geocode(
        {
          address: text,
        },
        function (results, status) {
          if (status === window.google.maps.GeocoderStatus.OK) {
            for (var i in results) {
              if (results[0].geometry) {
                var latlng = results[0].geometry.location;
                if (dep) {
                  setDepLatLng(latlng);
                } else {
                  setDesLatLng(latlng);
                }
              }
            }
          } else if (
            status === window.google.maps.GeocoderStatus.ZERO_RESULTS
          ) {
            let tex = "目的地";
            if (dep) {
              tex = "出発地";
            }
            alert(tex + "が見つかりませんでした");
          } else {
            alert("GooleMapで場所情報取得中にエラーが発生しました");
          }
          loadingEndMini();
        },
      );
    },
    onClickOpenSelectSpot() {
      this.openSelectSpotModal = true;
    },
    onClickCloseSelectSpot() {
      this.openSelectSpotModal = false;
    },
    async searchRoute() {
      const directionsService = new window.google.maps.DirectionsService();
      const now = new Date();

      try {
        const response = await directionsService.route({
          origin: this.currentSearchDep,
          destination: this.currentSearchDes,
          travelMode: window.google.maps.TravelMode.DRIVING,
          drivingOptions: {
            departureTime: now,
            trafficModel: "bestguess",
          },
        });
        const param = {
          ...this.currentSearch,
          departureTime: now,
          route: response,
          index: 0,
        };

        // ログ処理
        if (this.currentSearch.departure !== this.currentSearch.destination) {
          const actionParams = {
            start: this.currentSearch.departure,
            start_lon: this.currentDepLatLng.lng(),
            start_lat: this.currentDepLatLng.lat(),
            start_time: now,
            goal: this.currentSearch.destination,
            goal_lat: this.currentDesLatLng.lng(),
            goal_lon: this.currentDesLatLng.lat(),
            current_lat: this.currentLat,
            current_lon: this.currentLng,
          };

          await Firebase.putLog({
            ActionType: "SearchRoute",
            ActionParams: actionParams,
          });
        } else {
          const actionParams = {
            start_lon: this.currentDepLatLng.lng(),
            start_lat: this.currentDepLatLng.lat(),
          };
          await Firebase.putLog({
            ActionType: "SearchNearSpots",
            ActionParams: actionParams,
          });
        }

        this.setSearch(param);
        this.setSearchState("select");
      } catch (error) {
        window.alert(
          "経路検索時にエラーが発生しました。条件を変更するか、時間をあけて再度お試しください。",
        );
      }
    },
    zeroPaddingAndStr(num) {
      if (num < 10) {
        return "0" + String(num);
      }
      return String(num);
    },
  },
  data() {
    return {
      aroundAreaData: [],
      openSelectSpotModal: false,
    };
  },
  async mounted() {
    // これはデバッグ用;
    // const now = new Date();
    // this.onClickSearch({
    //   departure: "東京駅",
    //   destination: "清里駅",
    //   departureTime: now,
    // });
    this.loadingStartMini();
    let param = {
      api_key: "i73rauGTyfewa",
      registration_id: this.registrationId,
    };
    await axios
      .get(
        "https://mission-kqxgrnovcq-uc.a.run.app/api/areas",
        { params: param },
      )
      .then((response) => {
        this.aroundAreaData = response.data;
      });
    this.loadingEndMini();
  },
};
</script>

<style lang="scss" scoped>
@import "./../../unified.scss";
.route-search {
  height: 100%;

  .tab {
    display: flex;
    color: #d8d8d8;
    .tab-item {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      border-bottom: #e7e7e7 2px solid;
      height: 1.8rem;
      font-size: 1rem;
      font-weight: 700;

      &.current {
        border-bottom: #5cd5d6 2px solid;
        color: #5cd5d6;
      }
    }
  }
  .map-area {
    height: calc(100% - 7.7rem);
    &.tab1 {
      height: calc(100% - 4.8rem);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/RouteSearch.vue